import { useSessionTree } from '@services/session'
import { Select, SelectProps } from '@shared/Form/Select'
import React from 'react'
import { useTranslation } from 'react-i18next'

type CityOption = { value: number; label: string }

export const CitySelect = ({
  supportAll,
  ...props
}: SelectProps & { supportAll?: boolean }) => {
  const { t } = useTranslation()

  const { baseLayer, loading } = useSessionTree()

  const cityOptions: CityOption[] = React.useMemo(
    () =>
      baseLayer?.children?.map((item: any) => ({
        value: item.id,
        label: item.name,
      })) || [],
    [baseLayer]
  )

  return (
    <Select loading={loading} {...props}>
      {supportAll && (
        <Select.Option value={-1} key={0}>
          {t('common:all')}
        </Select.Option>
      )}
      {cityOptions?.map((x: any) => (
        <Select.Option key={x.value} value={x.value}>
          {x.label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default CitySelect
